import { render, staticRenderFns } from "./customerServiceStatisticsDetail.vue?vue&type=template&id=2e58fa08&scoped=true&"
import script from "./customerServiceStatisticsDetail.vue?vue&type=script&lang=js&"
export * from "./customerServiceStatisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerServiceStatisticsDetail.vue?vue&type=style&index=0&id=2e58fa08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e58fa08",
  null
  
)

component.options.__file = "customerServiceStatisticsDetail.vue"
export default component.exports